// Bilingual editorial content for INTOLLEЯANTIA Brand Book
// Structure: content[chapter_key][lang]

export const CHAPTERS = [
    { key: "cover", roman: "I", slug: "cover" },
    { key: "opening", roman: "II", slug: "opening" },
    { key: "philosophy", roman: "III", slug: "philosophy" },
    { key: "values", roman: "IV", slug: "values" },
    { key: "manifesto", roman: "V", slug: "manifesto" },
    { key: "mirroredR", roman: "VI", slug: "mirrored-r" },
    { key: "voice", roman: "VII", slug: "tone-of-voice" },
    { key: "logo", roman: "VIII", slug: "logo" },
    { key: "palette", roman: "IX", slug: "palette" },
    { key: "typography", roman: "X", slug: "typography" },
    { key: "photography", roman: "XI", slug: "photography" },
    { key: "packaging", roman: "XII", slug: "packaging" },
    { key: "product", roman: "XIII", slug: "product" },
    { key: "storytelling", roman: "XIV", slug: "storytelling" },
    { key: "experience", roman: "XV", slug: "experience" },
    { key: "website", roman: "XVI", slug: "website" },
    { key: "social", roman: "XVII", slug: "social" },
    { key: "retail", roman: "XVIII", slug: "retail" },
    { key: "rules", roman: "XIX", slug: "rules" },
    { key: "closing", roman: "XX", slug: "closing" },
    { key: "contact", roman: "XXI", slug: "contact" },
];

export const UI = {
    en: {
        read: "Read",
        presentation: "Presentation",
        chapter: "Chapter",
        of: "of",
        index: "Index",
        close: "Close",
        exportPdf: "Export PDF",
        payoff: "Italian Maison — Rare Editions",
        registered: "® Registered Trademark",
        scroll: "Scroll",
        continue: "Continue",
        next: "Next",
        prev: "Previous",
        contactUs: "Distributor Enquiry",
        submit: "Submit Enquiry",
        submitting: "Sending…",
        success: "Enquiry received. We reply within 48 hours.",
        failure: "Something went wrong. Please retry.",
        name: "Full name",
        email: "Email",
        company: "Company / Maison",
        country: "Country",
        message: "Message",
        category: "Category of interest",
        catFood: "Food",
        catBeauty: "Beauty",
        catHome: "Home",
    },
    it: {
        read: "Sfoglia",
        presentation: "Presentazione",
        chapter: "Capitolo",
        of: "di",
        index: "Indice",
        close: "Chiudi",
        exportPdf: "Esporta PDF",
        payoff: "Maison Italiana — Edizioni Rare",
        registered: "® Marchio Registrato",
        scroll: "Scorri",
        continue: "Prosegui",
        next: "Avanti",
        prev: "Indietro",
        contactUs: "Richiesta Distributori",
        submit: "Invia richiesta",
        submitting: "Invio…",
        success: "Richiesta ricevuta. Rispondiamo entro 48 ore.",
        failure: "Qualcosa è andato storto. Riprova.",
        name: "Nome completo",
        email: "Email",
        company: "Azienda / Maison",
        country: "Paese",
        message: "Messaggio",
        category: "Categoria di interesse",
        catFood: "Food",
        catBeauty: "Bellezza",
        catHome: "Casa",
    },
};

export const CONTENT = {
    cover: {
        en: {
            eyebrow: "MMXXVII — Brand Book",
            title: "INTOLLERANTIA",
            payoff: "Italian Maison — Rare Editions",
            note: "Volume I · The Founding Document",
        },
        it: {
            eyebrow: "MMXXVII — Brand Book",
            title: "INTOLLERANTIA",
            payoff: "Maison Italiana — Edizioni Rare",
            note: "Volume I · Documento Fondativo",
        },
    },
    opening: {
        en: {
            eyebrow: "A Fragment",
            body: "The mirrored Я is the sign of those who choose a different direction. Not the market. Excellence.",
        },
        it: {
            eyebrow: "Un frammento",
            body: "La Я specchiata è il segno di chi sceglie una direzione diversa. Non il mercato. L'eccellenza.",
        },
    },
    philosophy: {
        en: {
            eyebrow: "III — Philosophy",
            title: "Three Pillars",
            mission: {
                label: "Mission",
                body: "To restore rarity to the everyday. We select, we do not produce; we edit, we do not manufacture. Every bottle, jar and vessel is a limited edition of the Italian territory it comes from.",
            },
            vision: {
                label: "Vision",
                body: "A world where quantity has surrendered to meaning. Where a table, a bathroom, a home holds fewer objects — but each one carries a story worth telling twice.",
            },
            principle: {
                label: "Core Principle",
                body: "Less quantity. More value. Less noise. More authenticity. The mirrored Я turns its back on the market to face the source.",
            },
        },
        it: {
            eyebrow: "III — Filosofia",
            title: "Tre Pilastri",
            mission: {
                label: "Missione",
                body: "Restituire la rarità al quotidiano. Selezioniamo, non produciamo; editiamo, non fabbrichiamo. Ogni bottiglia, vaso e recipiente è un'edizione limitata del territorio italiano da cui proviene.",
            },
            vision: {
                label: "Visione",
                body: "Un mondo in cui la quantità ha ceduto al significato. Dove una tavola, un bagno, una casa ospitano meno oggetti — ma ciascuno porta una storia che vale la pena raccontare due volte.",
            },
            principle: {
                label: "Principio Fondante",
                body: "Meno quantità. Più valore. Meno rumore. Più autenticità. La Я specchiata volta le spalle al mercato per guardare la fonte.",
            },
        },
    },
    values: {
        en: {
            eyebrow: "IV — Values",
            title: "Six Non-Negotiables",
            items: [
                {
                    n: "01",
                    label: "Rarity",
                    body: "Numbered lots. Never restocked.",
                },
                {
                    n: "02",
                    label: "Slowness",
                    body: "Harvest time is not marketing time.",
                },
                {
                    n: "03",
                    label: "Origin",
                    body: "One estate. One name. One responsibility.",
                },
                {
                    n: "04",
                    label: "Restraint",
                    body: "The label speaks last, and softly.",
                },
                {
                    n: "05",
                    label: "Ritual",
                    body: "Every opening is a ceremony.",
                },
                {
                    n: "06",
                    label: "Refusal",
                    body: "We say no more than we say yes.",
                },
            ],
        },
        it: {
            eyebrow: "IV — Valori",
            title: "Sei Non Negoziabili",
            items: [
                {
                    n: "01",
                    label: "Rarità",
                    body: "Lotti numerati. Mai riordinati.",
                },
                {
                    n: "02",
                    label: "Lentezza",
                    body: "Il tempo del raccolto non è quello del marketing.",
                },
                {
                    n: "03",
                    label: "Origine",
                    body: "Una tenuta. Un nome. Una responsabilità.",
                },
                {
                    n: "04",
                    label: "Sobrietà",
                    body: "L'etichetta parla per ultima, e a bassa voce.",
                },
                {
                    n: "05",
                    label: "Rito",
                    body: "Ogni apertura è una cerimonia.",
                },
                {
                    n: "06",
                    label: "Rifiuto",
                    body: "Diciamo no più spesso di quanto diciamo sì.",
                },
            ],
        },
    },
    manifesto: {
        en: {
            eyebrow: "V — Manifesto",
            title: "The Founding Text",
            body: [
                "We were born tired of abundance.",
                "Of shelves that repeat themselves, of names that mean nothing, of oils that could be from anywhere and therefore are from nowhere.",
                "Intollerantia is a maison of refusal. We refuse volume, we refuse compromise, we refuse the belief that Italy is a marketing category. Italy is a landscape, a dialect, a pair of hands, and a specific November light on the sea between Trapani and Marettimo.",
                "We publish oil the way an editor publishes a rare book: numbered, signed, in editions small enough to remember. We choose the estate before the crop, the farmer before the yield, the silence before the noise.",
                "The mirrored Я is our silent gesture. It looks back where everyone else looks forward. It refuses the applause of the market and searches, instead, for the applause of the source.",
            ],
        },
        it: {
            eyebrow: "V — Manifesto",
            title: "Il Testo Fondativo",
            body: [
                "Siamo nati stanchi dell'abbondanza.",
                "Di scaffali che si ripetono, di nomi che non significano nulla, di oli che potrebbero venire da qualsiasi luogo e per questo non vengono da nessuno.",
                "Intollerantia è una maison del rifiuto. Rifiutiamo il volume, rifiutiamo il compromesso, rifiutiamo l'idea che l'Italia sia una categoria di marketing. L'Italia è un paesaggio, un dialetto, un paio di mani, e una specifica luce di novembre sul mare tra Trapani e Marettimo.",
                "Pubblichiamo olio come un editore pubblica un libro raro: numerato, firmato, in edizioni sufficientemente piccole da poter essere ricordate. Scegliamo la tenuta prima del raccolto, il contadino prima della resa, il silenzio prima del rumore.",
                "La Я specchiata è il nostro gesto silenzioso. Guarda dove tutti gli altri non guardano più. Rifiuta l'applauso del mercato e cerca, invece, l'applauso della fonte.",
            ],
        },
    },
    mirroredR: {
        en: {
            eyebrow: "VI — The Mirrored Я",
            title: "A Direction Against The Market",
            block: [
                "The mirrored Я is the symbol of those who choose a different direction.",
                "It does not follow the market — it follows excellence.",
                "That is why Intollerantia looks at the world from the opposite perspective:",
                "less quantity, more value. Less noise, more authenticity.",
            ],
            caption:
                "Reserved for identity applications. Never decorative. Never rotated. Never explained.",
        },
        it: {
            eyebrow: "VI — La Я Specchiata",
            title: "Una Direzione Contro Il Mercato",
            block: [
                "La R specchiata è il simbolo di chi sceglie una direzione diversa.",
                "Non segue il mercato, segue l'eccellenza.",
                "Per questo Intollerantia guarda il mondo da una prospettiva opposta:",
                "meno quantità, più valore. Meno rumore, più autenticità.",
            ],
            caption:
                "Riservata alle applicazioni d'identità. Mai decorativa. Mai ruotata. Mai spiegata.",
        },
    },
    voice: {
        en: {
            eyebrow: "VII — Tone of Voice",
            title: "How We Speak",
            do: [
                "Speak slowly. Use short sentences.",
                "Name places before adjectives.",
                "Prefer the specific to the general.",
                "Leave space between statements — silence is a punctuation mark.",
            ],
            dont: [
                "Never use superlatives (best, finest, unique).",
                "Never boast about awards.",
                "Never write the word luxury.",
                "Never explain the mirrored Я.",
            ],
        },
        it: {
            eyebrow: "VII — Tono di Voce",
            title: "Come Parliamo",
            do: [
                "Parliamo piano. Usiamo frasi brevi.",
                "Prima i luoghi, poi gli aggettivi.",
                "Prima il concreto, poi il generale.",
                "Lasciamo spazio tra le affermazioni — il silenzio è una punteggiatura.",
            ],
            dont: [
                "Mai superlativi (migliore, finissimo, unico).",
                "Mai vantarsi di premi.",
                "Mai scrivere la parola lusso.",
                "Mai spiegare la Я specchiata.",
            ],
        },
    },
    logo: {
        en: {
            eyebrow: "VIII — Logo Guidelines",
            title: "The Registered Lockup",
            variants: [
                {
                    name: "Primary",
                    use: "Full lockup on ivory. Default. Most uses.",
                },
                {
                    name: "Inverted",
                    use: "Full lockup on absolute black. Boutique, bags, night applications.",
                },
                {
                    name: "Compact",
                    use: "Wordmark alone, no payoff. Constrained spaces, social headers.",
                },
                {
                    name: "Prestige (Gold Я)",
                    use: "Я rendered in champagne gold. Packaging, certificates, embossed print only.",
                },
                {
                    name: "Monogram Seal",
                    use: "Mirrored Я in a gold hairline ring with curved micro-type. Wax, tissue, favicon.",
                },
                {
                    name: "Wax Seal",
                    use: "Matte black wax embossed with Я. Boxes, certificates, envelopes.",
                },
            ],
            rule: "Clear space equals the height of the Я. Never below 24px on screen, 8mm on print.",
        },
        it: {
            eyebrow: "VIII — Marchio",
            title: "Il Lockup Registrato",
            variants: [
                {
                    name: "Primario",
                    use: "Lockup completo su avorio. Default. Uso principale.",
                },
                {
                    name: "Invertito",
                    use: "Lockup completo su nero assoluto. Boutique, buste, applicazioni notturne.",
                },
                {
                    name: "Compatto",
                    use: "Solo wordmark, senza payoff. Spazi ridotti, header social.",
                },
                {
                    name: "Prestige (Я oro)",
                    use: "Я in oro champagne. Packaging, certificati, stampa a rilievo.",
                },
                {
                    name: "Monogramma Sigillo",
                    use: "Я specchiata in un anello dorato con micro-tipografia curva. Cera, velina, favicon.",
                },
                {
                    name: "Sigillo di Cera",
                    use: "Cera nera opaca con Я a rilievo. Scatole, certificati, buste.",
                },
            ],
            rule: "L'area di rispetto è pari all'altezza della Я. Mai sotto 24px a schermo, 8mm in stampa.",
        },
    },
    palette: {
        en: { eyebrow: "IX — Colour", title: "The Locked Palette" },
        it: { eyebrow: "IX — Colore", title: "La Palette Registrata" },
    },
    typography: {
        en: {
            eyebrow: "X — Typography",
            title: "A Dual System",
            didone: {
                use: "Didone — Bodoni Moda. Food category. Heritage. Classical. All display sizes.",
                specimen: "AaBbCcDdEeFfGgHhIiJjKk 1234567890",
            },
            contemporary: {
                use: "Cormorant Garamond. Beauty & Home. Poetic long-form. Body text.",
                specimen: "AaBbCcDdEeFfGgHhIiJjKk 1234567890",
            },
        },
        it: {
            eyebrow: "X — Tipografia",
            title: "Un Sistema Duale",
            didone: {
                use: "Didone — Bodoni Moda. Categoria food. Patrimonio. Classica. Tutte le dimensioni display.",
                specimen: "AaBbCcDdEeFfGgHhIiJjKk 1234567890",
            },
            contemporary: {
                use: "Cormorant Garamond. Beauty & Home. Long-form poetico. Corpo testo.",
                specimen: "AaBbCcDdEeFfGgHhIiJjKk 1234567890",
            },
        },
    },
    photography: {
        en: {
            eyebrow: "XI — Photography",
            title: "The Mediterranean Gaze",
            body: "One horizon. One hand. One light. Photograph what can be touched, not what can be sold.",
            cues: [
                "November light. Never August.",
                "Wet hands, dry hands, working hands.",
                "The sea between Trapani and Marettimo — always with grain.",
                "Olive groves before harvest, salt pans at dusk.",
            ],
        },
        it: {
            eyebrow: "XI — Fotografia",
            title: "Lo Sguardo Mediterraneo",
            body: "Un orizzonte. Una mano. Una luce. Fotografiamo ciò che si tocca, non ciò che si vende.",
            cues: [
                "Luce di novembre. Mai agosto.",
                "Mani bagnate, mani asciutte, mani che lavorano.",
                "Il mare tra Trapani e Marettimo — sempre con grana.",
                "Uliveti prima del raccolto, saline al tramonto.",
            ],
        },
    },
    packaging: {
        en: {
            eyebrow: "XII — Packaging",
            title: "The Ritual of the Object",
            body: "Every vessel is opaque, matte, cold to the touch. The oil sleeps in absolute darkness until served.",
            formats: [
                {
                    label: "Monocultivar",
                    spec: "250ml — opaque black bottle",
                },
                { label: "Blender", spec: "250ml — bottle" },
                { label: "Blender", spec: "500ml — tin" },
                { label: "Blender", spec: "1L — bottle" },
                { label: "Blender", spec: "5L — tin" },
            ],
            layers: [
                "Rigid box, natural cotton lining",
                "Numbered certificate on cotton paper",
                "Matte black wax seal — mirrored Я",
                "Tissue paper — monogram print",
                "Ivory cotton shopping bag",
                "Shipping box — untreated cardboard",
            ],
            note: "Label data (harvest year, acidity, cultivar %, estate coordinates) — to be inserted post-frantoio.",
        },
        it: {
            eyebrow: "XII — Packaging",
            title: "Il Rito dell'Oggetto",
            body: "Ogni recipiente è opaco, matte, freddo al tatto. L'olio dorme in oscurità assoluta fino al servizio.",
            formats: [
                {
                    label: "Monocultivar",
                    spec: "250ml — bottiglia nera opaca",
                },
                { label: "Blender", spec: "250ml — bottiglia" },
                { label: "Blender", spec: "500ml — latta" },
                { label: "Blender", spec: "1L — bottiglia" },
                { label: "Blender", spec: "5L — latta" },
            ],
            layers: [
                "Scatola rigida, fodera di cotone naturale",
                "Certificato numerato su carta di cotone",
                "Sigillo in cera nera opaca — Я specchiata",
                "Carta velina — stampa monogramma",
                "Shopper di cotone avorio",
                "Scatola di spedizione — cartone non trattato",
            ],
            note: "Dati etichetta (annata, acidità, % cultivar, coordinate tenuta) — da inserire dopo il frantoio.",
        },
    },
    product: {
        en: {
            eyebrow: "XIII — Product Philosophy",
            title: "Four Collections",
            lines: [
                {
                    n: "01",
                    label: "Founder",
                    body: "The founder's private harvest. Never sold. Only offered.",
                },
                {
                    n: "02",
                    label: "Estate",
                    body: "Single-estate monocultivars. Numbered lots.",
                },
                {
                    n: "03",
                    label: "Selected",
                    body: "Blends composed by the maison from Italian estates.",
                },
                {
                    n: "04",
                    label: "Future",
                    body: "Beauty and home editions — under composition.",
                },
            ],
        },
        it: {
            eyebrow: "XIII — Filosofia di Prodotto",
            title: "Quattro Collezioni",
            lines: [
                {
                    n: "01",
                    label: "Founder",
                    body: "Il raccolto privato del fondatore. Mai venduto. Solo offerto.",
                },
                {
                    n: "02",
                    label: "Estate",
                    body: "Monocultivar di tenuta. Lotti numerati.",
                },
                {
                    n: "03",
                    label: "Selected",
                    body: "Blend composti dalla maison su tenute italiane.",
                },
                {
                    n: "04",
                    label: "Future",
                    body: "Edizioni beauty e casa — in composizione.",
                },
            ],
        },
    },
    storytelling: {
        en: {
            eyebrow: "XIV — Storytelling",
            title: "Western Sicily",
            body: "We tell the story of one place before we tell the story of a product. Trapani, Marettimo, the salt pans, the olives that grow in the wind between the two.",
        },
        it: {
            eyebrow: "XIV — Narrazione",
            title: "Sicilia Occidentale",
            body: "Raccontiamo la storia di un luogo prima di quella di un prodotto. Trapani, Marettimo, le saline, gli ulivi che crescono nel vento tra le due.",
        },
    },
    experience: {
        en: {
            eyebrow: "XV — Experience",
            title: "The Unboxing",
            steps: [
                "The shipping box opens without noise — no tape.",
                "The cotton bag reveals the rigid box.",
                "The rigid box lifts on a hinge, revealing the certificate.",
                "The wax seal cracks — the bottle appears.",
                "The reader begins.",
            ],
        },
        it: {
            eyebrow: "XV — Esperienza",
            title: "L'Unboxing",
            steps: [
                "La scatola di spedizione si apre senza rumore — nessun nastro.",
                "Il sacchetto di cotone rivela la scatola rigida.",
                "La scatola rigida si solleva a cerniera, rivelando il certificato.",
                "Il sigillo di cera si spezza — la bottiglia appare.",
                "Il lettore comincia.",
            ],
        },
    },
    website: {
        en: {
            eyebrow: "XVI — Website",
            title: "Digital Behaviour",
            body: "Editorial. Bilingual. Slow. The website is a room, not a shop. It closes at midnight, in spirit.",
        },
        it: {
            eyebrow: "XVI — Sito",
            title: "Comportamento Digitale",
            body: "Editoriale. Bilingue. Lento. Il sito è una stanza, non un negozio. Chiude a mezzanotte, nello spirito.",
        },
    },
    social: {
        en: {
            eyebrow: "XVII — Social",
            title: "Instagram Grid",
            body: "Nine cells. Three rows of three. Two photographs, one still, one text. Never a face without a name.",
        },
        it: {
            eyebrow: "XVII — Social",
            title: "Griglia Instagram",
            body: "Nove celle. Tre righe di tre. Due fotografie, una still, un testo. Mai un volto senza un nome.",
        },
    },
    retail: {
        en: {
            eyebrow: "XVIII — Retail",
            title: "Where We Live",
            body: "Five-star hotels, private clubs, yachts, fine dining, editorial concept stores. Never supermarkets. Never airports.",
        },
        it: {
            eyebrow: "XVIII — Retail",
            title: "Dove Viviamo",
            body: "Hotel cinque stelle, club privati, yacht, fine dining, concept store editoriali. Mai supermercati. Mai aeroporti.",
        },
    },
    rules: {
        en: {
            eyebrow: "XIX — Brand Rules",
            title: "Ten Absolutes",
            rules: [
                "Never rotate the mirrored Я.",
                "Never explain the mirrored Я.",
                "Never place the logo on a coloured background outside the palette.",
                "Never write the word luxury.",
                "Never use superlatives.",
                "Never restock a numbered lot.",
                "Never sell in airports or supermarkets.",
                "Never use gloss print.",
                "Never use drop shadows.",
                "Never break the silence.",
            ],
        },
        it: {
            eyebrow: "XIX — Regole",
            title: "Dieci Assoluti",
            rules: [
                "Mai ruotare la Я specchiata.",
                "Mai spiegare la Я specchiata.",
                "Mai posare il marchio su un fondo colorato fuori palette.",
                "Mai scrivere la parola lusso.",
                "Mai usare superlativi.",
                "Mai riordinare un lotto numerato.",
                "Mai vendere in aeroporti o supermercati.",
                "Mai stampa lucida.",
                "Mai ombre portate.",
                "Mai rompere il silenzio.",
            ],
        },
    },
    closing: {
        en: {
            eyebrow: "XX — Closing Promise",
            title: "Our Silent Word",
            body: "We will not grow beyond what we can name. We will not sign what we have not touched. We will not speak of what does not exist.",
            signature: "The Maison",
        },
        it: {
            eyebrow: "XX — Promessa Finale",
            title: "La Nostra Parola Silenziosa",
            body: "Non cresceremo oltre ciò che sappiamo nominare. Non firmeremo ciò che non abbiamo toccato. Non parleremo di ciò che non esiste.",
            signature: "La Maison",
        },
    },
    contact: {
        en: {
            eyebrow: "XXI — Distributor",
            title: "Enter The Conversation",
            body: "We reply, personally, within 48 hours. To every enquiry we accept, we send a printed sample of the founding certificate.",
        },
        it: {
            eyebrow: "XXI — Distributori",
            title: "Entra nella Conversazione",
            body: "Rispondiamo, personalmente, entro 48 ore. A ogni richiesta accettata inviamo un esemplare stampato del certificato fondativo.",
        },
    },
};

export const PALETTE = [
    {
        name: "Absolute Black",
        hex: "#0B0B0B",
        cmyk: "60 40 40 100",
        rgb: "11 11 11",
        pantone: "Black 6 C",
    },
    {
        name: "Warm Ivory",
        hex: "#F4EFE6",
        cmyk: "3 5 10 0",
        rgb: "244 239 230",
        pantone: "11-0507 Marshmallow",
    },
    {
        name: "Champagne Gold",
        hex: "#C9A96A",
        cmyk: "20 30 65 5",
        rgb: "201 169 106",
        pantone: "16-1144 Amber Gold",
    },
    {
        name: "Stone Beige",
        hex: "#D9CDB8",
        cmyk: "12 15 30 0",
        rgb: "217 205 184",
        pantone: "13-1006 Almond Oil",
    },
    {
        name: "Mediterranean White",
        hex: "#FBF9F4",
        cmyk: "1 2 4 0",
        rgb: "251 249 244",
        pantone: "11-0602 Snow White",
    },
    {
        name: "Dark Olive",
        hex: "#3A3E2C",
        cmyk: "60 50 80 60",
        rgb: "58 62 44",
        pantone: "19-0512 Beech",
    },
];

export const IMAGES = {
    salt1: "https://images.pexels.com/photos/38324808/pexels-photo-38324808.jpeg?auto=compress&cs=tinysrgb&w=1600",
    salt2: "https://images.pexels.com/photos/19448326/pexels-photo-19448326.jpeg?auto=compress&cs=tinysrgb&w=1600",
    olive1: "https://images.pexels.com/photos/11086294/pexels-photo-11086294.jpeg?auto=compress&cs=tinysrgb&w=1600",
    olive2: "https://images.pexels.com/photos/34803738/pexels-photo-34803738.jpeg?auto=compress&cs=tinysrgb&w=1600",
    hands1: "https://images.unsplash.com/photo-1534953342533-7711c98712be?auto=format&fit=crop&w=1600&q=80",
    hands2: "https://images.unsplash.com/photo-1721508490084-1b1de5b230d4?auto=format&fit=crop&w=1600&q=80",
    bottle1:
        "https://images.pexels.com/photos/10924522/pexels-photo-10924522.jpeg?auto=compress&cs=tinysrgb&w=1600",
    bottle2:
        "https://images.pexels.com/photos/5894/design-decoration-glasses-interior.jpg?auto=compress&cs=tinysrgb&w=1600",
    sea: "https://images.unsplash.com/photo-1505142468610-359e7d316be0?auto=format&fit=crop&w=1600&q=80",
    marettimo:
        "https://images.unsplash.com/photo-1520962880247-cfaf541c8724?auto=format&fit=crop&w=1600&q=80",
    oliveTree:
        "https://images.unsplash.com/photo-1601557557153-46ae2d38fef1?auto=format&fit=crop&w=1600&q=80",
    oilPour:
        "https://images.unsplash.com/photo-1620705981296-4f5b6ce7f43f?auto=format&fit=crop&w=1600&q=80",
    bottles:
        "https://customer-assets-4nw71qhi.emergentagent.net/job_intollerantia-book/artifacts/5ay60buq_foto%20bottiglie.jpg",
    saline1:
        "https://customer-assets-4nw71qhi.emergentagent.net/job_intollerantia-book/artifacts/htyyxv25_IMG-20260722-WA0024.jpg",
    saline2:
        "https://customer-assets-4nw71qhi.emergentagent.net/job_intollerantia-book/artifacts/6lahhnr5_IMG-20260722-WA0025.jpg",
    saline3:
        "https://customer-assets-4nw71qhi.emergentagent.net/job_intollerantia-book/artifacts/w56610lt_IMG-20260722-WA0026.jpg",
    saline4:
        "https://customer-assets-4nw71qhi.emergentagent.net/job_intollerantia-book/artifacts/rrpafwgi_IMG-20260722-WA0027.jpg",
    saline5:
        "https://customer-assets-4nw71qhi.emergentagent.net/job_intollerantia-book/artifacts/mwzyn2dp_IMG-20260722-WA0028.jpg",
    saltJarGrani:
        "https://customer-assets-4nw71qhi.emergentagent.net/job_intollerantia-book/artifacts/tjhcyjfg_barattolo%20del%20sale.png",
    saltJarFiocchi:
        "https://customer-assets-4nw71qhi.emergentagent.net/job_intollerantia-book/artifacts/rd452cxk_barattolo%20del%20sale%20fiocchi.png",
    honeyJar:
        "https://customer-assets-4nw71qhi.emergentagent.net/job_intollerantia-book/artifacts/nih7pqia_miele%20.png",
};
